module.exports = __webpack_public_path__ + "static/media/Avatars_Male-15.3c63573c.png";